import { render, staticRenderFns } from "./inject-tag.vue?vue&type=template&id=8577a1f6"
import script from "./inject-tag.vue?vue&type=script&lang=js"
export * from "./inject-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports